<template>
    <v-card>
        <v-card-title>
            <v-layout justify-space-around wrap>
              <v-flex xs1>
                <v-btn
                  icon
                  color="primary"
                  small
                  @click="function () {
                    if (step === 1) $emit('fechar')
                    else step = 1
                  }"
                >
                  <v-icon>{{step !== 1 ? 'arrow_back' : 'close'}}</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs9>
                <h1 class="text-xs-center">{{titulo}}</h1>
              </v-flex>
              <v-flex xs1>
                <v-btn
                  icon
                  color="primary"
                  small
                  v-if="step===1"
                  @click="step = 3"
                >
                  <v-icon>list</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
        </v-card-title>
        <v-card-text>
          <v-stepper v-model="step" style="box-shadow:none;">
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0 ma-0">
                <v-layout justify-center>
                  <v-icon size="100" color="primary">card_giftcard</v-icon>
                </v-layout>
                <v-tabs
                  v-model="tabs"
                  grow
                  color="transparent"
                  slider-color="primary"
                >
                  <v-tab>Por ID</v-tab>
                  <v-tab>Por Código</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs">
                  <v-tab-item lazy>
                    <v-text-field
                        v-model="pesquisa"
                        :loading="loading"
                        box
                        hide-details
                        single-line
                        color="primary"
                        clearable
                        class="centered-input display-1 font-weight-black"
                    />
                  </v-tab-item>
                  <v-tab-item lazy>
                    <v-text-field
                        v-model="pesquisa"
                        :loading="loading"
                        box
                        hide-details
                        single-line
                        color="primary"
                        clearable
                        class="centered-input display-1 font-weight-black"
                    />
                  </v-tab-item>
                </v-tabs-items>
                  <v-list two-line dense>
                    <template v-for="(voucherPremio, index) in vouchersPremio">
                      <v-divider :key="`${index}d`"></v-divider>
                      <v-list-tile
                        :key="`${index}list`"
                        ripple
                        style="cursor: pointer"
                        @click="selectVoucherPremio(voucherPremio)"
                      >
                        <v-list-tile-action>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                <v-icon color="secondary">card_giftcard</v-icon>
                              </span>
                            </template>
                            <span>Prêmio</span>
                          </v-tooltip>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{
                            voucherPremio.data_gerado
                              .split("-")
                              .reverse()
                              .join("/")
                          }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-content>
                          <v-list-tile-title style="text-align: center">{{
                            voucherPremio.premio.nome
                          }}</v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon color="primary" small>
                            <v-icon>visibility</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </template>
                  </v-list>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-0 ma-0">
                <template v-if="premiacaoSelecionada">
                  <v-layout justify-center>
                    <img
                      v-if="premiacaoSelecionada.premio.url_imagem"
                      :src="premiacaoSelecionada.premio.url_imagem"
                      alt="Imagem do prêmio"
                      width="200"
                    />
                    <v-icon size="100" color="primary" v-else>card_giftcard</v-icon>
                  </v-layout>
                  <v-layout wrap justify-space-around fill-height style="font-size: 1.1em">
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          Nome: <b>{{ premiacaoSelecionada.premio.nome }}</b>
                      </h4>
                    </v-flex>
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          Descrição: <b>{{ premiacaoSelecionada.premio.descricao }}</b>
                      </h4>
                    </v-flex>
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          Código: <b>{{ premiacaoSelecionada.codigo }}</b>
                      </h4>
                    </v-flex>
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          Data: <b>{{ premiacaoSelecionada.data_gerado.split("-").reverse().join("/") }}</b>
                      </h4>
                    </v-flex>
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          Nome do cliente: <b>{{ premiacaoSelecionada.cliente.pessoa.nome_completo }}</b>
                      </h4>
                    </v-flex>
                    <v-flex xs5>
                      <h4 style="font-weight: 500;" class="mb-2 mt-2">
                          ID: <b>{{ premiacaoSelecionada.cliente.pessoa.id_pessoa }}</b>
                      </h4>
                    </v-flex>
                  </v-layout>
                </template>
              </v-stepper-content>
              <v-stepper-content step="3" class="pa-0 ma-0">
                <v-list three-line class="pt-0">
                  <template v-for="(vp, index) in premiosRetirados">
                    <v-divider v-if="index > 0" :key="`${index}div`" inset></v-divider>
                    <v-list-tile
                      avatar
                      :key="`${index}l`"
                    >
                      <v-list-tile-action>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <v-icon color="primary">card_giftcard</v-icon>
                            </span>
                          </template>
                          <span>{{vp.premio.nome}}</span>
                        </v-tooltip>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ vp.premio.nome }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          v-text="vp.premio.descricao"
                        ></v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          v-if="vp.cliente"
                          class="grey--text text--darken-3 caption font-weight-medium"
                          v-text="`Retirado por ${vp.cliente.pessoa.nome_completo}`"
                        ></v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          class="grey--text text--darken-3 caption font-weight-medium"
                          v-text="`Data de retirada: ${vp.data_inativado}`"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
                <v-layout justify-space-between v-if="!pagination.page === 0">
                  <v-flex xs1>
                    <v-btn
                      icon
                      small
                      @click="pagination.page--"
                      color="primary"
                      :disabled="pagination.page == 1"
                    >
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                  </v-flex>
                  <v-flex xs9>
                    <v-layout justify-center>
                      <v-avatar>
                        <v-btn icon small color="primary">
                          {{pagination.page}}
                        </v-btn>
                      </v-avatar>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      small
                      @click="pagination.page++"
                      :disabled="pagination.page == pages"
                      color="primary"
                    >
                      <v-icon>arrow_forward</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
        <v-card-text v-if="step===2">
            <v-layout justify-space-around wrap class="mb-2">
                <v-flex xs9>
                    <h6
                        class="mb-2 text-xs-center"
                        style="
                            font-size: 1.1em;
                            margin-left: 9em;
                        "
                    >
                        Digite o PIN do frentista responsável
                    </h6>
                </v-flex>
                <v-flex xs3>
                    <v-btn
                        round
                        color="primary"
                        small
                        @click="selecionarFrentista = true"
                    >
                        Alterar frentista
                    </v-btn>
                </v-flex>
                <v-flex xs2>
                    <v-icon size="40">engineering</v-icon>
                </v-flex>
                <v-flex xs10>
                    <h4>Lido por: {{frentistaSelecionado.nome}}</h4>
                    <h4>Matricula: {{frentistaSelecionado.matricula}}</h4>
                </v-flex>
            </v-layout>
            <Pin v-if="!autenticado" :frentista="frentistaSelecionado" @autenticado="autenticado = true"/>
            <h3 v-else class="success--text text-xs-center mt-3 mb-3">A leitura já pode ser realizada</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            block
            class="mb-1"
            :disabled="(step === 1 && !pesquisa) || (step === 2 && !autenticado)"
            @click="function () {
              if (step === 1) pegarVouchersPremio()
              else lerVoucherPremio()
            }"
            v-if="step !== 3"
          >
            <v-icon v-if="step===1" class="mr-1">search</v-icon>
            {{step === 1 ? 'Pesquisar' : 'Marcar como retirado'}}
          </v-btn>
        </v-card-actions>
        <v-dialog
            v-if="selecionarFrentista"
            v-model="selecionarFrentista"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <selecionar-frentista
                @fechar="selecionarFrentista = false, autenticado = false"
            />
        </v-dialog>
    </v-card>
</template>

<script>

import Pin from '@/components/Pin'
import SelecionarFrentista from '@/components/dialogs/DialogSelecionarFrentista'

export default {
  components: { Pin, SelecionarFrentista },
  data: () => ({
    step: 1,
    pesquisa: undefined,
    vouchersPremio: [],
    premiosRetirados: [],
    totalItens: 0,
    premiacaoSelecionada: undefined,
    tabs: 0,
    selecionarFrentista: false,
    autenticado: false,
    pagination: {
      rowsPerPage: 5,
      page: 1
    }
  }),
  computed: {
    titulo () {
      if (this.step === 1) return 'Procurar por premios'
      else if (this.step === 2) return 'Detalhes do premio'
      else return 'Prêmios retirados'
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      let count = this.totalItens
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  watch: {
    pagination: {
      handler (val, oldval) {
        this.carregarPremios()
      },
      deep: true
    },
    tabs () {
      this.pesquisa = undefined
    },
    step (val) {
      if (val === 3) this.carregarPremios()
    }
  },
  methods: {
    selectVoucherPremio (vp) {
      this.premiacaoSelecionada = vp
      this.step++
    },
    carregarPremios () {
      this.$store.dispatch('pegarVoucherPremio', {
        'page': this.pagination.page
      }).then(value => {
        this.premiosRetirados = value.results
        this.totalItens = value.count
      })
    },
    pegarVouchersPremio () {
      const data = {}
      if (this.tabs === 0) data.id_pessoa = this.pesquisa
      else data.codigo = this.pesquisa
      this.$store.dispatch('voucherPremio', data).then(list => {
        this.vouchersPremio = list
      })
    },
    lerVoucherPremio () {
      this.$store.dispatch('lerVoucherPremio', {
        id_voucher: this.premiacaoSelecionada.id,
        cnpj: this.posto.cnpj,
        id_frentista: this.frentistaSelecionado.id_frentista
      }).then(() => {
        this.premiacaoSelecionada = undefined
        this.step = 1
      })
    }
  }
}
</script>
